import { render, staticRenderFns } from "./UserResetMyPassword.vue?vue&type=template&id=1c6368ef"
import script from "./UserResetMyPassword.vue?vue&type=script&lang=js"
export * from "./UserResetMyPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/UserResetMyPassword.vue
// module id = null
// module chunks = 